var descriptionListThemeWeb = {
  label: {
    fontSize: 18,
    color: 'text.secondary'
  },
  description: {
    fontWeight: 500,
    fontSize: 18,
    color: 'text'
  },
  dividerColor: 'border.light'
};

export { descriptionListThemeWeb };
